<template>
  <div style="height:100%;position:relative">
    <div style="height:100%" class="flex">
      <div class="history">
        <div class="select flex">
          <div
            v-for="(item, index) in list"
            class="choose"
            :class="chooseIndex === index ? 'check' : 'uncheck'"
            :key="index"
            @click="changeClick(item, index)"
          >
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div class="charts">
          <loadEchart ref="echarts"></loadEchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { getWlwSoilGetToDay } from "@/api/zhwl";
import { findRealData, findHistoryData } from "@/api/zhwl";
import { wlwSoilData } from "@/api/base";
import { sqOptions } from "@/util/sqOptions";
export default {
  data() {
    return {
      sqForm: {},
      list: [{ name: "温度" }, { name: "湿度" }],
      chooseIndex: 0,
      timeIndex: 0,
      equimentIds: [],
      equimentTimes: [],
      sqDatas: [
        {
          name: "10cm温度",
          sname: "10",
          sname1: "温",
          value: "--",
          unit: "℃",
          indexs: [],
          echartsData: [],
        },
        {
          name: "10cm湿度",
          sname: "10",
          sname1: "湿",
          value: "--",
          channel: "6",
          unit: "%",
          type: "humi",
          indexs: [],
          echartsData: [],
        },
        {
          name: "20cm温度",
          sname: "20",
          sname1: "温",
          value: "--",
          channel: "5",
          unit: "℃",
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "20cm湿度",
          sname: "20",
          sname1: "湿",
          value: "--",
          channel: "3",
          unit: "%",
          top: "5%",
          type: "temp",
          indexs: [],
          echartsData: [],
        },
        {
          name: "40cm温度",
          sname: "40",
          sname1: "温",
          value: "--",
          channel: "5",
          unit: "℃",
          top: "20%",
          type: "direction",
          indexs: [],
          echartsData: [],
        },
        {
          name: "40cm湿度",
          sname: "40",
          sname1: "湿",
          value: "--",
          channel: "3",
          unit: "%",
          top: "5%",
          type: "temp",
          indexs: [],
          echartsData: [],
        },
      ],
    };
  },
  mounted() {
    // this.initChart();
    this.getData();
    // this.dataLoad();
  },
  methods: {
    initChart() {
      // this.sqCharts = this.$echarts.init(this.$refs.sq);
      // window.addEventListener("resize", () => {
      //   this.sqCharts.resize();
      // });
    },
    getData() {
      this.$refs.echarts.showLoading();
      this.equimentIds = [];
      this.equimentTimes = [];
      // getWlwCode().then((res) => {
      // getWlwCode().then((res) => {
      let res = {
        data: window.deviceData,
      };
      if (res && res.data && res.data.soil) this.deviceCode = res.data.soil;
      else this.deviceCode = "CJ02A-2110027";
      findRealData(this.deviceCode)
        .then((res) => {
          if (
            res.code == 200 &&
            res.data &&
            res.data.sensor &&
            res.data.sensor.length > 0
          ) {
            const sensor = res.data.sensor;

            this.sqDatas.map((item) => {
              sensor.some((ele) => {
                if (
                  ele.name.indexOf(item.sname) > -1 &&
                  ele.name.indexOf(item.sname1) > -1
                ) {
                  item.name = ele.name;
                  item.unit = ele.sensor_type_unit || ele.unit || "";
                  item.value = ele.value || "";
                  item.echartsData = [];
                  item.indexs = [];
                  this.equimentIds.push(ele.id);

                  return true;
                }
              });

              return item;
            });
            console.log(
              "气象站",
              this.equimentIds,
              this.sqDatas,
              this.equimentIds.length > 0
            );
            debugger;
            if (this.equimentIds.length > 0) this.getHistoryData();
          } else this.$refs.echarts.noOption();
        })
        .catch(() => {
          this.$refs.echarts.noOption();
        });
      // });
    },
    getHistoryData(
      ids = "equimentIds",
      type = "sqDatas",
      timeType = "equimentTimes"
    ) {
      this.$refs.echarts.showLoading();
      console.log("getHistoryData");
      let start_time = `${this.$formatDate(new Date(), "yyyy-MM-dd")} 00:00:00`;

      const end_time = this.$formatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
      let group_type = this.timeIndex == 0 ? 4 : 5;
      const data = {
        sensor_ids: this[ids].join(","),
        group_type,
        start_time,
        end_time,
      };
      console.log("end_time", this.timeIndex, data);
      findHistoryData(data)
        .then((res) => {
          if (
            res.code == 200 &&
            res.data &&
            res.data.sensor &&
            res.data.sensor.length > 0 &&
            res.data.time &&
            res.data.time.length > 0
          ) {
            const datas = res.data;
            this[timeType] = datas.timestamp.map((it) => {
              return this.$formatDate(new Date(it), "MM-dd hh时");
            });
            this[type].map((item) => {
              datas.sensor.some((it) => {
                if (
                  it.hd_device_sensor_name.indexOf(item.sname) > -1 &&
                  it.hd_device_sensor_name.indexOf(item.sname1) > -1
                ) {
                  item.echartsData = it.data ? it.data : it.avg_data;
                  item.echartsData = item.echartsData.map((ele) => {
                    return ele || 0;
                  });
                  item.indexs = it.index;
                  return true;
                }
              });
              return item;
            });

            this.$refs.echarts.setOptions(this.getOptions());
          }
        })
        .catch(() => {
          this.$refs.echarts.noOption();
        });
    },
    getOptions() {
      let datas = [];
      let type = this.chooseIndex == 0 ? "温" : "湿",
        unit = this.chooseIndex == 0 ? "℃" : "%";
      this.sqDatas.map((item) => {
        if (item.name.indexOf(type) > -1) {
          datas.push(item);
        }
      });
      console.log("getOptions", datas);
      return sqOptions(datas, this.equimentTimes, unit);
    },
    dataLoad() {
      wlwSoilData({ wllSoilCode: "SQ03B-2000020" }).then((res) => {
        this.sqForm = res.data;
      });
    },
    changeClick(item, index) {
      if (this.chooseIndex == index) return;
      this.chooseIndex = index;
      this.$refs.echarts.setOptions(this.getOptions());
    },
  },
  destroyed() {},
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.now
  width 30%
  height 100%
  background url('~images/index/zhwl/sqtz.png') no-repeat
  background-size 10% 90%
  background-position 10%
  position relative
.ten,.twenty,.thidty
  position absolute
  width 100%
  color #fff
  justify-content space-evenly
.ten
  top 15%
.twenty
  top 40%
.thidty
  top 63%
.num
  color $textColor
  font-size 15px
.pointRine
  position relative
  &:before
    content ''
    position absolute
    height 1px
    background #fff
    width 100%
    top 8px
    left 30px
.history
  width 100%
  height 100%
.charts
  position relative
  height 100%
.select
  position absolute
  right 0
  top 10px
  z-index 1001
  color #fff
.choose
  cursor pointer
.choose:nth-child(1)
  border-radius 3px 0 0 3px
  border-right 0
.choose:nth-child(2)
  border-radius 0 3px 3px 0
  border-left 0
.check
  color #333
  background $textColor
  border 1px solid $textColor
  padding 5px 3px
.uncheck
  color #fff
  padding 3px
  border 1px solid $textColor
</style>
